import _ from 'lodash';
import { createSelector } from 'reselect';

import { getAppSettings } from './AppConfigsSelectors';
import { ENTITY_NAME_DASHBOARD } from '../constants/SavedSearches';
import { DEFAULT_DASHBOARD_KEY, GLOBAL_DASHBOARD_KEY } from '../containers/Dashboard/constants';
import { isFalse } from '../utils/commonUtils';

export const getDashboardConfig = (state) => state.dashboardConfig;
export const getDashboardSavedSearches = (state) =>
  _.get(state, ['savedSearches', ENTITY_NAME_DASHBOARD, 'searches'], []);

export const getSavedSearchResultsState = (state) => _.get(state, ['savedSearchResults'], {});

export const sActive = (state) => {
  return state.auth.isExternalUser
    ? 'externaluser'
    : _.get(state, ['dashboardConfig', 'personalization', 'active']);
};
export const sMode = (state) => _.get(state, ['dashboardConfig', 'personalization', 'mode']);
export const sPartConfig = (state) =>
  _.get(state, ['dashboardConfig', 'personalization', 'config'], {});
export const sPartDraft = (state) =>
  _.get(state, ['dashboardConfig', 'personalization', 'draft']) ?? {};
export const sData = (state) => _.get(state, ['dashboard', 'data']);

export const sActivePartConfig = createSelector(
  [sActive, sPartConfig],
  (active, partConfig) => partConfig[active] || {}
);
export const sActivePartDraft = createSelector(
  [sActive, sPartDraft],
  (active, partDraft) => partDraft[active] || {}
);

export const getParts = createSelector(
  [sActivePartConfig, sActivePartDraft, sMode, getAppSettings],
  (partConfig, partDraft, mode, appSettings) => {
    const part = mode !== 'general' ? partDraft : partConfig;
    const isMyTrainingTaskDisabled = isFalse(
      appSettings?.['SmartSolve/DisplayMyTrainingTasksInDashboard']
    );

    return Object.keys(part)
      .map((id) => ({ ...part[id], id }))
      .filter(
        (part) => part.enabled && !(isMyTrainingTaskDisabled && part.name === 'My Training Tasks')
      );
  }
);

export const hasContent = ({ visualization, graph }) => {
  if (visualization === 'embedded') {
    return graph.embeddedUrl !== '';
  }
  return true;
};

export const visibleTabs = (tab) => !tab.hidden && hasContent(tab);

export const getVisibleParts = createSelector([getParts, sMode], (parts, mode) => {
  return parts.filter(
    (part) => !part.hidden && (mode === 'edit' || part.tabs.filter(visibleTabs).length !== 0)
  );
});

export const getMode = createSelector([sMode], (mode) => mode);

export const getPartData = (id) => createSelector([sData], (data) => data[id]);

export const getShowDashboardSwitcher = createSelector(
  [getDashboardConfig],
  (dashboardConfig) =>
    dashboardConfig.userSpecificDashboard && dashboardConfig.globalDefaultDashboard
);

export const getIsDashboardPersonalized = createSelector(
  [getDashboardConfig],
  (dashboardConfig) =>
    dashboardConfig.code !== DEFAULT_DASHBOARD_KEY && dashboardConfig.code !== GLOBAL_DASHBOARD_KEY
);
